export const SUP_ONLINE_TOOLS_LANDING_PAGE_LOADER = {
  desktop: `
<div class="cui">
  <div class="cui-grid">
    <div class="cui-container" style="line-height: 0;">

      <!-- Breadcrumbs skeleton -->
      <div class="cui-skeleton-paragraph__content -spacing--top-40 -spacing--bottom-40" style="width: 50%;">
        <div class="cui-skeleton__item" style="height: 24px"></div>
      </div>

      <!-- Title Skeleton -->
      <div>
        <div class="cui-skeleton-heading__content -spacing--top-24 -spacing--bottom-8" style="width: 30%;">
          <div class="cui-skeleton__item" style="height: 52px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading__content -spacing--bottom-48" style="width: 60%;">
        <div class="cui-skeleton__item" style="height: 28px"></div>
      </div>

      <!-- Filters Skeleton -->
      <div>
        <div class="cui-skeleton-paragraph__content -spacing--bottom-64" style="width: 50%">
          <div class="cui-skeleton__item" style="height: 48px"></div>
        </div>
      </div>

      <!-- Tool Group Section - most popular -->
      <div class="cui-skeleton-heading__content -spacing--top-40 -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
        <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;">
        </div>
      </div>

      <!-- Tool Group Section - one row -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Tool Group Section - one row -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Tool Group Section - two rows -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-40" style="width: 100%; height: 270px;"></div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Tool Group Section - two rows -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-40" style="width: 100%; height: 270px;"></div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Tool Group Section - one row -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Tool Group Section - one row -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Tool Group Section - two rows -->
      <div class="cui-skeleton-heading__content -spacing--bottom-24" style="width: 30%">
        <div class="cui-skeleton__item" style="height: 32px"></div>
      </div>
      <div class="cui-skeleton__item -spacing--bottom-40" style="width: 100%; height: 270px;"></div>
      <div class="cui-skeleton__item -spacing--bottom-64" style="width: 100%; height: 270px;"></div>

      <!-- Additional spacing -->
      <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 56px;"></div>

    </div>
  </div>
</div>
`
};
